import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import { Moment } from 'moment';
import DatePicker from './DatePicker';

interface Props extends BaseFieldProps {
	value?: Moment | null;
	onChange?: (date: Moment | null) => void;
	disabled?: boolean;
	minDate?: Moment;
	maxDate?: Moment;
}

const DatePickerField: React.FC<Props> = props => {
	return (
		<BaseField {...props}>
			<DatePicker
				value={props.value}
				onChange={props.onChange}
				disabled={props.disabled}
				maxDate={props.maxDate}
				minDate={props.minDate}
			/>
		</BaseField>
	);
};

export default DatePickerField;
